import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import RefseqTranscripts from "./RefseqTranscripts";
import EnsemblTranscripts from "./EnsemblTranscripts/EnsemblTranscripts";
import {
  getEnsemblTranscripts,
  getRefSeqTranscripts,
  getSchema,
} from "./selectors/transcriptsSelectors.selectors";
import {
  getError,
  getGenomeName,
  getLoading,
  getIsFLT3ITD,
  getVariantResult,
  getVarsomeHost,
} from "../../../../state/selectors/general.selectors";
import { whiteColor } from "../../../../common/helpers/colors";
import HelperText from "../../../../components/atoms/HelperText";

const { arrayOf, shape, string, bool } = PropTypes;

const Transcripts = ({
  refseq_transcripts: refseqTranscripts,
  ensembl_transcripts: ensmblTranscripts,
  loading,
  error,
  schema,
  variantResult,
  varsomeHost,
  genomeName,
  isFLT3ITD,
}) => {
  if (loading || error) return null;
  return (
    <>
      {refseqTranscripts || ensmblTranscripts ? (
        <div className="varsome-result-fixed">
          <div className="varsome-container">
            <div
              className="varsome-title tw-font-bold tw-text-left"
              style={{ backgroundColor: whiteColor }}
            >
              Transcripts
              <HelperText fieldDescriptionKey="Transcripts" />
            </div>
            <div className="varsome-inner-container">
              <RefseqTranscripts
                schema={schema}
                variantResult={variantResult}
                varsomeHost={varsomeHost}
                genomeName={genomeName}
                isFLT3ITD={isFLT3ITD}
              />
              <EnsemblTranscripts
                schema={schema}
                variantResult={variantResult}
                varsomeHost={varsomeHost}
                genomeName={genomeName}
                isFLT3ITD={isFLT3ITD}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="varsome-result">
          <div className="varsome-container varsome-container__basic">
            <div className="varsome-title tw-font-semibold">
              Transcripts
              <HelperText fieldDescriptionKey="Transcripts" />
            </div>
            <div className="varsome-inner-container">
              No data available for this variant in RefSeq transcripts and
              Ensembl transcripts.
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  refseq_transcripts: getEnsemblTranscripts(state),
  ensembl_transcripts: getRefSeqTranscripts(state),
  loading: getLoading(state),
  variantResult: getVariantResult(state),
  schema: getSchema(state),
  error: getError(state),
  varsomeHost: getVarsomeHost(state),
  genomeName: getGenomeName(state),
  isFLT3ITD: getIsFLT3ITD(state),
});

Transcripts.propTypes = {
  refseq_transcripts: arrayOf(
    shape({
      items: arrayOf(
        shape({
          name: string,
          strand: string,
          coding_impact: string,
          function: arrayOf(string),
          hgvs: string,
          hgvs_p1: string,
          hgvs_p3: string,
          location: string,
          coding_location: string,
          canonical: bool,
          gene_symbol: string,
          splice_distance: string,
          ensembl_support_level: string,
        })
      ),
      version: string,
    })
  ),
  ensembl_transcripts: arrayOf(
    shape({
      items: arrayOf(
        shape({
          name: string,
          strand: string,
          coding_impact: string,
          function: arrayOf(string),
          hgvs: string,
          hgvs_p1: string,
          hgvs_p3: string,
          location: string,
          coding_location: string,
          canonical: bool,
          gene_symbol: string,
          splice_distance: string,
          ensembl_support_level: string,
        })
      ),
      version: string,
    })
  ),
  loading: bool,
  error: string,
  variantResult: shape({}),
  schema: shape({}),
  varsomeHost: string,
  genomeName: string,
  isFLT3ITD: bool,
};
Transcripts.defaultProps = {
  refseq_transcripts: null,
  ensembl_transcripts: null,
  loading: false,
  error: null,
  variantResult: {},
  schema: {},
  varsomeHost: null,
  genomeName: null,
  isFLT3ITD: false,
};
export default connect(mapStateToProps)(Transcripts);
